export enum TicketsChildTab {
  TicketType = 'settings/ticket/type',
  Properties = 'settings/ticket/property',
  AnswerTemplate = 'settings/ticket/template',
  Priority = 'settings/ticket/priority',
  Services = 'settings/ticket/service',
}

export const TicketsTabList = [
  {
    id: TicketsChildTab.TicketType,
    title: 'Loại ticket',
  },
  {
    id: TicketsChildTab.Properties,
    title: 'Thuộc tính',
  },
  {
    id: TicketsChildTab.AnswerTemplate,
    title: 'Mẫu trả lời',
  },
  {
    id: TicketsChildTab.Priority,
    title: 'Mức ưu tiên',
  },
  {
    id: TicketsChildTab.Services,
    title: 'Dịch vụ',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(TicketsChildTab).forEach(s => {
    if (url.includes(TicketsChildTab[s])) {
      tab = TicketsChildTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/tickets.const.ts